export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/pt-br.lyaml"));
vm(require("feature-monetization/lang/pt-br.lyaml"));
at({ "pt-br": { "publicPricingPage": { "windowTitles": { "default": "Pre\xE7os | HubSpot" } } } });
};